import {
  CalibrationAccelerometer,
  CalibrationCompass,
  CalibrationGyroscope,
  CalibrationLevelHorizon,
  ConfigurationParameters,
  FailsafeBattery,
  FailsafeGCS,
  FailsafeRadio,
  PreflightInspection,
} from '@/define/commandSet/mavlink';

const setup = [
  {
    name: 'Calibration',
    commands: [CalibrationAccelerometer, CalibrationCompass, CalibrationLevelHorizon, CalibrationGyroscope],
  },
  {
    name: 'Failsafe',
    commands: [FailsafeBattery, FailsafeRadio, FailsafeGCS],
  },
  {
    name: 'Configuration',
    commands: [ConfigurationParameters],
  },
  {
    name: 'Preflight',
    commands: [PreflightInspection],
  },
];

export default setup;
